import posthog from 'posthog-js'
import {
  activateInternalAnalyticsBrowserFromLink,
  INTERNAL_ANALYTICS_DISTINCT_ID,
  isInternalAnalyticsBrowser,
} from './src/lib/internal-analytics'
import { trackOutreachLanding } from './src/lib/outreach-tracking'

activateInternalAnalyticsBrowserFromLink()

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: '/ingest',
  ui_host: 'https://eu.posthog.com',
  defaults: '2026-01-30',
  capture_exceptions: true,
  debug: process.env.NODE_ENV === 'development',
  loaded: (client) => {
    if (isInternalAnalyticsBrowser()) {
      client.identify(INTERNAL_ANALYTICS_DISTINCT_ID, {
        name: 'Frank (Servd)',
        is_internal: true,
      })
    } else {
      if (client.get_distinct_id() === INTERNAL_ANALYTICS_DISTINCT_ID) {
        client.reset()
      }
      // Pas na SDK-initialisatie opslaan en opschonen, vóór de eerste pageview.
      // Eigen klikken in een interne browser vervuilen de schooldata niet.
      trackOutreachLanding(client, window)
    }
  },
})
